import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'bypassHtmlSanitizer', standalone: true })
export class BypassHtmlSanitizerPipe implements PipeTransform {
    constructor(private _sanitizer: DomSanitizer) {}

    transform(html: string): SafeHtml {
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }
}
